import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputLabelContainer } from '../../../../../common/components/form/label/containers/input-label.container';
import { format } from '../../../../../common/services/date.service';
export const LeadBasicInfoComponent = ({ leadDetails, getCategoryName }: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <div> <InputLabelContainer
                            label="Name"
                        />
                            <InputLabelContainer
                                label={leadDetails?.LeadInfo?.Name}
                            /></div>
                        <div><InputLabelContainer
                            label="Email"
                        />
                            <InputLabelContainer
                                label={leadDetails?.LeadInfo?.Email}
                            /></div>
                        <div> <InputLabelContainer
                            label="PhoneNumber"
                        />
                            <InputLabelContainer
                                label={leadDetails?.LeadInfo?.PhoneNumber}
                            /></div>
                        <div> <InputLabelContainer
                            label="ProductName"
                        />
                            <InputLabelContainer
                                label={leadDetails?.LeadInfo?.MobilityProductName}
                            /></div>
                        <div> <InputLabelContainer
                            label="VariantName"
                        />
                            <InputLabelContainer
                                label={leadDetails?.LeadInfo?.MobilityVariantName}
                            /></div>
                        <div> <InputLabelContainer
                            label="Description"
                        />
                            <InputLabelContainer
                                label={leadDetails?.LeadInfo?.Description}
                            /></div>

                    </div>
                }
                expandedPanel="userInfo"
                headerTitle="Basic Info"
            />

        </>
    )
}
export default LeadBasicInfoComponent;
